import { render, staticRenderFns } from "./WebAppDetail.vue?vue&type=template&id=87fea4b8&scoped=true"
import script from "./WebAppDetail.vue?vue&type=script&lang=js"
export * from "./WebAppDetail.vue?vue&type=script&lang=js"
import style0 from "./WebAppDetail.vue?vue&type=style&index=0&id=87fea4b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fea4b8",
  null
  
)

export default component.exports